import DesignSystemButton from '../../../components/Button/DesignSystemButton';
import Images from '../../../state/stores/Image/images';
import Loading from '../../../components/Loading/Loading';
import React from 'react';
import Title from '../../../components/Title/Title';
import WebHeader from '../../../components/WebHeader/WebHeader';
import { ADD_CONTACT } from '../../../state/mutations/User';
import { AntDesign, Entypo } from '@expo/vector-icons';
import { AssistanceStackParamList} from '../../../types/navigation';
import { BIG_FONT_SIZE_FN, REGULAR_MARGIN_VERTICAL_FN, SMALL_MARGIN_VERTICAL_FN, isIos, isWeb } from '../../../config/designSystem/Layout';
import { BLACK, COLORS, ERROR_COLOR, NEUTRAL_TEXT500, YELLOW } from '../../../config/designSystem/Colors';
import { BOTTOM_SPACING_SCROLLVIEW, SPACING } from '../../../config/designSystem/Spacing';
import { ConfirmDialog } from '../../../components/Modal/ConfirmDialog';
import { Contacted } from '../../../components/Library/Contacted';
import { FlatList, Image, Linking, ScrollView,StyleSheet, TouchableOpacity, View } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import { H3, H4, ParagraphMRegular, ParagraphSBold, ParagraphSRegular } from '../../../config/designSystem/typography';
import { RibbonPsychoCard } from '../../../assets/images/ribbonPsychoCard';
import { assistanceKey } from '../../../constants/routeKeys';
import { concatPath } from '../../../utils/links/concatPath';
import { observer } from 'mobx-react';
import { router, useLocalSearchParams } from 'expo-router';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useIsSmallWeb } from '../../../hooks/ui/useIsSmallWeb';
import { useMutation } from '@apollo/client';
import { useStores } from '../../../hooks/useStores';
import { useTabBarHeight } from '../../../components/NavigationPanel/TabBarHeightContext';



const MARGIN_VERTICAL = 8;
type AssistanceProps = AssistanceStackParamList['PsychologistDetail'];
const PsychoDetails: React.FunctionComponent<AssistanceProps> = observer(s => {
  const rootStore = useStores();
  const params = useLocalSearchParams<AssistanceProps>();

  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;
  const [loading, setLoading] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const contact = rootStore?.psychologist.isInContact(params._id);
  console.log('contact', contact);
  const { height, width } = useAvailableDimensions();
  const [addContactMutation] = useMutation(
    ADD_CONTACT, {
      fetchPolicy:'no-cache'
    }
  );
  const psycho = rootStore?.psychologist.getPsychologist(params._id);
  const name = psycho?.firstName + ' ' + psycho?.lastName;
  const criteria = psycho?.criteria?.filter((crit: any) => !!crit.status);
  const BUTTON_WIDTH= 250;
  const leftMargin = (width-BUTTON_WIDTH)/2;
  const location='map-marker';
  const {tabBarHeight} = useTabBarHeight();
  const {isLargeEnoughForLateralBarWeb} = useIsSmallWeb();

  const onAddContact = () => {
    setShowAlert(true);
  };


  const navigateAway = () => {
    if(router.canGoBack()) {
      router.back();
    } else {
      router.navigate(concatPath([assistanceKey],0) as string);
    }
  };


  const renderAltItem = (item2: any, idx: number, L: number) => {
    let text = item2.label;
    if (!!L && idx !== (L - 1)) {
      text = text + ', ';
    }
    return (
      <View key={idx.toString()}>
        <ParagraphSRegular color={item2.matched?COLORS.state.success.primary:ERROR_COLOR} >{text}</ParagraphSRegular>
      </View>
    );
  };


  //  tslint:disable-next-line: cyclomatic-complexity
  const renderItem = React.useCallback(({item }) => {
    if (item.status) {
      const listAlt = () => {
        const L = item?.results?.length;
        return item.results.map((item, idx) => renderAltItem(item, idx, L));
      };
      let green = false;
      let red = false;
      let yellow = false;
      if (!item.shouldDisplayAltResult || !item.altResult) {
        green = item.results.every((x: any) => x.matched);
        red = item.results.every((x: any) => !x.matched);
        yellow = !green && !red;
      }
      const color = green ? COLORS.state.success.primary : red ? ERROR_COLOR : yellow ? YELLOW : BLACK;
      return (
        <View key={item.id} style={{
          flex: 1,
          marginTop: 5,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <View style={{ minWidth: 10, margin:5, right:5 }} >
            {green && <AntDesign color={COLORS.state.success.primary} name='check-circle' size={20} />}
            {red && <Entypo color={ERROR_COLOR} name='circle-with-cross' size={20} />}
          </View>
          {(item.shouldDisplayLabel && item.label) &&
                        <View style={{ flex: 8 }}>
                          <ParagraphSBold  color={color} >
                            {item.label}
                          </ParagraphSBold>
                        </View>}

          {(item.shouldDisplayAltResult && item.altResult) && (
            <View style={{ flex: 8, marginBottom: 5 }}>
              <ParagraphSRegular>
                {' ' + item.altResult}
              </ParagraphSRegular>
            </View>)}
          {(item.shouldDisplayResults && item.results.length > 0) && (
            <View  style={{ flex: 8, justifyContent: 'flex-start', flexDirection: 'row', marginLeft: 10 }}>
              {listAlt()}
            </View>
          )
          }

        </View>
      );
    } else {
      return <></>;
    }
  }, [width]);


  const openGps = () => {
    let psychoLocalization = psycho?.psychoLocation;
    psychoLocalization = psychoLocalization.replace(/\s+/g, '+');
    if (isWeb) {
      const urlWeb =`https://www.google.com/maps/place/${psychoLocalization}`;
      Linking.openURL(urlWeb);
      return;
    } else {
      const platform = isIos ? 'apple' : 'google';
      Linking.openURL(`http://maps.${platform}.com/maps?daddr=${psychoLocalization}`);
    }};

  const renderInfoTitle = (iconName: string, title: string) => {
    return(
      <View style={{ marginBottom: 0.5 * REGULAR_MARGIN_VERTICAL_FN(height) }}>
        <View style={{ marginBottom: 0.5 * SMALL_MARGIN_VERTICAL_FN(height), flexDirection:'row', alignItems:'center'}}>
          <View style={{margin:2}}>
            <FontAwesome name={iconName} style={{color:NEUTRAL_TEXT500}} size={BIG_FONT_SIZE_FN(width)}/>
          </View>
          <View style={{paddingLeft:15}}>
            <H4 color={NEUTRAL_TEXT500} >
              {title}
            </H4>
          </View>
        </View>
      </View>);
  };

  const renderInfo = (title: string, text: string | undefined, iconName:string) => {
    return (
      <>
        {!!text && <View style={styles.psychoDetails}>
          {renderInfoTitle(iconName, title)}
          {iconName==location? <TouchableOpacity style={{flexDirection:'row', paddingTop: 10, columnGap: 8, alignItems: 'center'}}
            onPress={openGps}>
            <FontAwesome name={'link'} style={{color:COLORS.brand[500]}} size={BIG_FONT_SIZE_FN(width)}/>
            <ParagraphSRegular  flexWrap={true} color={COLORS.brand[500]}>
              {text}
            </ParagraphSRegular>
          </TouchableOpacity>:
            <ParagraphSRegular flexWrap={true}>
              {text}
            </ParagraphSRegular>}
        </View>
        }
      </>);
  };

  if (loading) {
    return (<Loading withLabel={false} />);
  }


  return (
    <View style={[styles.container, !isWeb && {paddingTop:30}]}>
      {!isWeb&&<Title
        legacy
        title={''}
        withBack={true}
        onBack={navigateAway}
        color={COLORS.brand[500] }
        size={24}
      />}
      {isWeb&& <WebHeader
        title={''}
        color={'#FFFF'}
        onPress={navigateAway}
      />}
      <ScrollView contentContainerStyle={[isLargeEnoughForLateralBarWeb && {
        marginTop:SMALL_MARGIN_VERTICAL_FN(height),width:'100%'},
      {paddingBottom: BOTTOM_SPACING_SCROLLVIEW + SPACING['sp-40']}]}>
        <ConfirmDialog
          visible={showAlert}
          title={labels?.PSYCHOLOGIST?.ALERT_TITLE}
          message={labels?.PSYCHOLOGIST?.ALERT_CONTENT}
          cancelText={labels?.PSYCHOLOGIST?.ALERT_CANCEL}
          confirmText={labels?.PSYCHOLOGIST?.ALERT_OK}
          onCancel={() => {
            setShowAlert(false);
          }}
          onConfirm={async () => {
            setShowAlert(false);
            setLoading(true);
            await addContactMutation({
              variables: {
                'psychologist': params._id
              }
            });
            rootStore?.psychologist.addToContact(
              params._id);
            setLoading(false);
          }}
        />
        <View style={{width:'100%'}}>
          <View style={[
            {backgroundColor:params.colorBackground, margin:MARGIN_VERTICAL, paddingHorizontal:15, borderRadius: 10}]}
          >
            <TouchableOpacity style={styles.textContainer}>
              <View><Image source={{ uri: psycho?.profileImage }} style={[
                styles.innerImage, { marginRight: 30 }]
              } ></Image></View>
              <View style={{rowGap: 15}}>
                <H3>
                  {name}
                </H3>
                <ParagraphMRegular>
                  {psycho?.psychoTitle}
                </ParagraphMRegular>
              </View>
            </TouchableOpacity>

            {contact && (
              isWeb ? (
                <Contacted label={labels?.CONTACTED_THERAPIST?labels?.CONTACTED_THERAPIST:''} />):
                (<View style={{position:'absolute', right: -8, top:-6, zIndex:10}}>
                  <RibbonPsychoCard color={'#4F9EB5'} title={labels?.CONTACTED_THERAPIST} />
                </View>)
            )
            }
          </View>
          <Image source={Images.assistance[params.background]} resizeMode='contain' width={100} height={100}
            style={[{position:'absolute', bottom:0, right:0, zIndex:1, width:100, height:100, marginRight:MARGIN_VERTICAL}]} />
        </View>
        {(!!criteria && criteria.length > 0) && (
          <View style={styles.psychoDetails}>
            {renderInfoTitle('puzzle-piece',labels?.PSYCHOLOGIST?.CRITERIA)}

            <FlatList
              contentContainerStyle={[styles.scrollContainer]}
              data={criteria}
              keyExtractor={(item, idx) => String(idx)}
              renderItem={renderItem}
            />
          </View>
        )}

        {
          renderInfo (labels?.PSYCHOLOGIST?.ABOUT,
            psycho?.psychoDescription,'user-md')
        }
        {
          renderInfo(labels?.PSYCHOLOGIST?.LOCALIZATION,
            psycho?.psychoLocation, 'map-marker')
        }
        {
          renderInfo(labels?.PSYCHOLOGIST?.SCHEDULE,
            psycho?.psychoTimetable, 'calendar')
        }


      </ScrollView>
      {!contact ?
        <View style={[{position:'absolute', bottom:100, left: 0, opacity:1, width, zIndex:1 },
          isLargeEnoughForLateralBarWeb && {bottom: 0},
          !isLargeEnoughForLateralBarWeb && {bottom: tabBarHeight + SPACING['sp-16']}]}>
          <View style={{marginHorizontal:leftMargin}}>
            <View style={{ justifyContent: 'space-around', alignItems: 'center' }}>
              <DesignSystemButton
                label={labels?.PSYCHOLOGIST?.ADD_CONTACT}
                onPress={onAddContact}
              />
            </View>

          </View>
        </View>  : null }
    </View>
  );
}
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 200,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  flex: { flex: 1 },
  innerImage: { width: 80, height: 80, borderRadius: 100 },
  scrollContainer: { paddingBottom: 0 },
  textDescription: {
    paddingTop:5,
    left:5,
  },
  textContainer: {
    alignItems: 'center' ,
    flexDirection:'row',
    borderRadius: 20,
    marginVertical: 20,
    paddingTop:10,
    paddingHorizontal: 15,
  },
  psychoDetails:{
    paddingHorizontal: 15,
    paddingBottom: 10,
    backgroundColor:'#fff',
    margin:MARGIN_VERTICAL,
    paddingTop:20,
    justifyContent:'center'

  },

  psychoCard:{
    bottom:0,
    right:0,
  }});

export default PsychoDetails;
